import {IMotorcycle} from "../interfaces/Interfaces";

export const getMotorcycleImageUrl = (motorcycle: IMotorcycle): string => {
    const imageName = motorcycle.imagesArray && motorcycle.imagesArray.length > 0
        ? motorcycle.imagesArray[0]
        : "";

    return imageName ? `https://fyd.ge/fyd-images/${motorcycle.makerName}/${imageName}` : "";
};
